import { indexBy, path, prop, contains } from 'ramda';

import companystructuretemplate from './structure.tpl.html';
import { getCompanyById } from '../../../../reducers/companies';
import {
  getUsers,
  getMasterUsers,
  getDirectorUsers,
  getBuyerUsers,
  getBaseUsers,
  isLoading as getStructureLoading,
} from '../../../../reducers/users';
import {
  getBudgetsByIds,
  getLoading as getBudgetsLoading,
} from '../../../../reducers/budgets';
import { getContractById } from '../../../../reducers/contracts';

export class CompanyStructure {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      validateEmail: CompanyStructure.validateEmail,
    });

    const unsubscribe = $ngRedux.connect(CompanyStructure.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  static mapStateToThis(state) {
    const $company = getCompanyById(state, state.router.currentParams.id);
    const $budgets = getBudgetsByIds(state, ($company && $company.budgets) || []);
    const $activeContract = getContractById(state,
      ($company && $company.activeContract) || undefined);

    return {
      auth: state.authentication,
      company: $company,
      router: state.router,
      masters: getMasterUsers(state),
      directors: getDirectorUsers(state),
      buyers: getBuyerUsers(state),
      bases: getBaseUsers(state),
      users: getUsers(state),
      budgetsById: Object.assign({}, state.budgets.byId),
      budgetsByOwner: indexBy(path(['owner', 'id']), $budgets),
      activeContract: $activeContract,
      loadingBudgets: getBudgetsLoading(state),
      loadingStructure: getStructureLoading(state),
      me: state.authentication.user,
    };
  }

  $onInit() {
    this.reqCompanyStructure(this.router.currentParams.id);
    this.reqCompanyBudgets(this.router.currentParams.id);
    this.showModalAdd = false;
    this.newUser = {};
  }

  /* eslint-disable */
  calcPercentage(credits, totalCredits) {
    if (totalCredits && totalCredits > 0 && credits) {
      return `(${Math.round((credits / totalCredits) * 100)}%)`;
    }

    return '';
  }

  getObjProperty(obj, property) {
    if (obj) {
      return prop(property, obj);
    }

    return undefined;
  }

  /* eslint-enable */

  createBudget(ownerId, parentBudgetId) {
    this.createBudgetStart(this.router.currentParams.id, ownerId, parentBudgetId);
  }

  updateBudgets({ id, value }) {
    this.updateBudgetStart(this.router.currentParams.id, id, value);
  }

  isLoggedInUserOfType(types) {
    return contains(this.auth.user.type, Array.isArray(types) ? types : [types]);
  }

  showAddModal(type) {
    this.newUser.type = type;
    this.newUser.companyId = this.company.id;
    this.showModalAdd = true;
  }

  closeAllModals() {
    this.showModalAdd = false;
    this.newUser = {};
  }

  confirmAddModal() {
    this.addUser(this.newUser);
  }

  getCreateAccountModalTitle(type) {
    const userType = this.getAccountTypeDescription(type);
    return this.$translate.instant('MODAL_TITLE_CREATE_ACCOUNT', {
      userType: userType.toUpperCase(),
    });
  }

  getAccountTypeDescription(type) {
    return this.$translate.instant(`ACCOUNT_TYPE_${type && type.toUpperCase()}`);
  }

  disableAdd() {
    const result = !this.newUser.firstName ||
      !this.newUser.lastName ||
      !this.validateEmail(this.newUser.email) ||
      (!this.newUser.companyId && this.newUser.type !== 'editor' && this.isLoggedInUserOfType(['editor']));
    return result;
  }

  static validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
    return re.test(String(email).toLowerCase());
  }
}

CompanyStructure.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const companyStructure = {
  template: companystructuretemplate,
  controller: CompanyStructure,
};
